import { ArtType } from "../../helpers/types";
import { Stateful, useStateful } from "../../hooks/useStateful";
import BottomLine from "../BottomLine";
import { RadioButton, RadioGroup } from "../Form/Radio";
import { artIcon } from "../Icons/Icons";

export type ArtButtonProps = {
  art: ArtType;
  selected: boolean;
  onClick: () => void;
  bottomLine?: boolean;
};

export function ArtButton({ art, selected, onClick, bottomLine }: ArtButtonProps): JSX.Element {
  return (
    <div className={`${selected ? "bg-ldir-blue-paler" : ""} px-4 formLabel`}>
      <RadioButton
        noBg
        dataTestId={art + "Button"}
        checked={selected}
        onChange={onClick}
        label={
          <div className="flex items-center">
            {artIcon(art)}
            <span className="text-xl ml-4 font-bold">{art}</span>
          </div>
        }
        id={art}
        name="art"
      />
      {bottomLine && <BottomLine />}
    </div>
  );
}

export type ArtButtonsProps = {
  selected?: Stateful<ArtType | undefined>;
  onClick?: (which: ArtType) => void;
};
export function ArtButtons({ selected, onClick }: ArtButtonsProps): JSX.Element {
  const localSelected = useStateful<ArtType | undefined>(undefined);
  const _selected = selected !== undefined ? selected : localSelected;
  const artButtons = [
    {
      art: ArtType.Elg,
    },
    {
      art: ArtType.Hjort,
    },
    {
      art: ArtType.Rådyr,
    },
    {
      art: ArtType.Villrein,
    },
  ];

  return (
    <RadioGroup>
      {artButtons.map((button, index) => {
        return (
          <ArtButton
            art={button.art}
            key={`${button.art}${index}`}
            selected={button.art == _selected.value}
            onClick={() => {
              _selected.set(button.art);
              onClick && onClick(button.art);
            }}
            bottomLine={index === artButtons.length - 1}
          />
        );
      })}
    </RadioGroup>
  );
}
